import { GET_SETTINGS_DATA } from './../constants/actionTypes'

export const getSettings = data => dispatch => {
  dispatch({
    type: GET_SETTINGS_DATA,
    data
  })
}
